import React from 'react';

export default props => (
  <svg {...props} version="1.1" viewBox="0 0 50 50">
    <g id="Page-1" fill="none" stroke="none" strokeWidth="1">
      <g id="Google-Play-50x50-Icon-Bordered">
        <g id="Rectangle-1-+-google-play">
          <rect
            height="48"
            id="Rectangle-1"
            width="48"
            rx="10"
            stroke="#9B9B9B"
            strokeWidth="2"
            x="1"
            y="1"
          />
          <path
            id="google-play"
            d="M15.644745,35.9650748 C15.2542029,35.8598787 15,35.4721398 15,34.8721315 L15,15.0667399 C15,14.5110408 15.2152373,14.1362622 15.5564301,14 L15.5564301,14 L25.2892072,25.0372633 L15.644745,35.9650748 L15.644745,35.9650748 Z M16.9845317,35.5446698 L28.6997237,28.9048922 L25.8463222,25.6690486 L16.9845317,35.5446698 L16.9845317,35.5446698 Z M28.7803956,21.0815167 L17.2284674,14.5327498 L25.8632139,24.3868759 L28.7803956,21.0815167 L28.7803956,21.0815167 Z M29.5641845,21.5258452 L34.0895939,24.0912915 C34.946426,24.577028 34.9542618,25.36003 34.0895939,25.8500947 L29.4496961,28.479833 L26.4233025,25.026059 L29.5641845,21.5258452 L29.5641845,21.5258452 Z"
            fill="#9B9B9B"
          />
        </g>
      </g>
    </g>
  </svg>
);
